
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import ForWhom from './components/ForWhom';
import Journey from './components/Journey';
import Relationship from './components/Relationship';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Purchase from './components/Purchase';
import Footer from './components/Footer';
import CookieConsent from '../../components/feature/CookieConsent';

export default function EnglishPage() {
  const [openPolicyId, setOpenPolicyId] = useState<string | null>(null);

  const handlePolicyClick = (policyType: 'privacy' | 'cookies') => {
    try {
      // Trigger the footer to open the policy
      const event = new CustomEvent('openPolicy', { detail: { policyType } });
      window.dispatchEvent(event);
    } catch (error) {
      console.error('Failed to dispatch policy event:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <ForWhom />
      <Journey />
      <Relationship />
      <Testimonials />
      <FAQ />
      <Purchase />
      <Footer />
      <CookieConsent language="en" onPolicyClick={handlePolicyClick} />
    </div>
  );
}
